module.exports = __webpack_public_path__ + "static/Banner-01dfbc9bcc1dab2706b6740adf623238.png";